import {
  useBoolean,
  usePagination,
  useToastr,
} from '@laxmimanogna/code-quick-components';
import { add, format } from 'date-fns';
import { createContext, useContext, useMemo, useState } from 'react';
import { SELF } from '../constants/constants';
import { getDateInterval } from '../pages/dashboard/getDateInterval';
import dashboardRepository from '../repositories/DashboardRepository';
import departmentDashboardRepository from '../repositories/DepartmentRepository';
import hospitalDashboardRepository from '../repositories/HospitalRepository';
import myChartRepository from '../repositories/MyChartRepository';
import { transformHierarchyResponse } from '../pages/dashboard/components/table_config/hierarchyTreeUtils';
import { getCurrentUserTypeIdObject } from '../utils/getCurrentUserTypeDetails';
import { AuthContext } from './AuthProvider';
import { ClientType } from '../utils/clientTypeUtils';
import { get } from 'react-hook-form';

export const DashboardContext = createContext({
  getProviders: async () => { },
  getHospitals: async () => { },
  getUploads: async () => { },

  getDepartments: async () => { },
  getPhysicians: async () => { },

  providers: [],
  hospitals: [],
  uploads: [],

  filterParams: {},
  handleApplyFilter: () => { },

  treeData: [],
  isHierarchyLoading: false,
  getHierarchyTree: async () => {},
  getHierarchyTreeWithMetrics: async () => {},

  isProviderLoading: false,
  isHospitalLoading: false,
  isUploadsLoading: false,
  isChartActivityLoading: false,
  isRevenueOppLoading: false,
  hospitalFilter: {},
  setHospitalFilter: () => { },
  providerFilter: {},
  setProviderFilter: () => { },

  isTotalUploadLoading: false,
  totalUpload: {},
  getTotalUploads: async () => { },
  isCQScoreLoading: false,
  cqScore: {},
  getCQScore: async () => { },
  isRVUOppLoading: false,
  rvuOpp: {},
  revenueOpp: {},
  chartActivity: {},
  getRVUOpp: async () => { },
  getChartActivity: async () => { },
  getChartActivityRvu: async () => { },
  getChartActivityUpcoded: async () => { },
  getChartActivityDowncoded: async () => { },
  getChartActivityModifier: async () => { },
  getRevenueOpp: async () => { },
  getChartAccuracyBreakdown: async () => { },
  chartAccuracyBreakdown: {},
  isChartAccuracyBreakdownLoading: false,
  getPotentialRevenue: async () => { },
  potentialRevenue: {},
  isPotentialRevenueLoading: false,
  getCQEstimatedRev: async () => { },
  cqEstimatedRev: {},
  isCQEstimatedRevLoading: false,
  charts: [],
  uploadedChartsActivityRvu: [],
  uploadedChartsActivityUpcoded: [],
  uploadedChartsActivityDowncoded: [],
  uploadedChartsActivityModifier: [],
  chartFilters: {},
  setChartFilters: () => { },
  getCharts: async () => { },
  getFileObjectByBatchId: async () => { },
  isFileLoading: false,
  getAIRisk: () => { },
  aiRisk: {},
  isAIRiskLoading: false,
  getRVUOppDropdown: async () => { },
  dropdown: [],
  setRVUOppFilter: () => { },
  rvuOppFilter: {},
  error: {},
  showComparison: false,
  setShowComparison: () => { },
  getFilterParams: () => { },

  //audit results
  getAuditResults: async paginationParams => { },
  auditResults: [],
  isFetchingAuditResults: false,
  isFetchingChartActivityRvu: false,
  isFetchingChartActivityUpcoded: false,
  isFetchingChartActivityDowncoded: false,
  isFetchingChartActivityModifier: false,
  setUserType: () => { },
  userTypes: {},

  chartCurrentPage: null,
  setChartCurrentpage: () => { },
  generateAiResponse: () => { },
  isGenerateAIResponseLoading: false,
  setIsGenerateAIResponseLoading: () => { },

  // for e&m
  getStateSpecialtiesMap: () => {},
  getAllStates: () => {},
  getAllSpecialties: () => {},
  stateSpecialtiesMapping: {},
  allStates: null,
  allSpecialties: null,
  eandmSelectedOptions: {},
  setEandMSelectedOptions: () => {}, 
  DEFAULT_CLIENT_STATE: {},
  DEFAULT_CLIENT_SPECIALTY: {},
  DEFAULT_CMS_STATE: {},
  DEFAULT_CMS_SPECIALTY: {},
  isRVUOppDropdownLoading: true,
  DEFAULT_EANDM_OPTIONS: {},
  DEFAULT_RVU_DOPDOWN: "",
  set_DEFAULT_RVU_DOPDOWN: () => {},
  totalBatchMetadata: {},
  setTotalBatchMetadata: () => {}
});

const yesterday = add(new Date(), {
  days: -1,
});
const selectedFilter = JSON.parse(localStorage.getItem('selectedFilter'));
const date_type = localStorage.getItem('dateType') || 'service_date'; 
let initialFilterParams = {};
if (selectedFilter) {
  if (selectedFilter.toLowerCase() === 'custom') {
    const selectedCustomDates = JSON.parse(
      window.localStorage.getItem('customDateFilter')
    );
    initialFilterParams = {
      label: 'custom',
      start_date: selectedCustomDates?.start_date
        ? new Date(selectedCustomDates?.start_date)
        : new Date(),
      end_date: selectedCustomDates?.end_date
        ? new Date(selectedCustomDates?.end_date)
        : new Date(),
      previous_start_date: selectedCustomDates?.previous_start_date
        ? new Date(selectedCustomDates?.previous_start_date)
        : new Date(),
      previous_end_date: selectedCustomDates?.previous_end_date
        ? new Date(selectedCustomDates?.previous_end_date)
        : new Date(),
    };
  } else {
    const data = getDateInterval(selectedFilter);
    initialFilterParams = {
      label: selectedFilter,
      ...data,
    };
  }
} else {
  initialFilterParams = {
    label: 'month',
    start_date: add(yesterday, {
      days: -30,
    }),
    end_date: yesterday,
    previous_start_date: add(yesterday, {
      days: -60,
    }),
    previous_end_date: add(yesterday, {
      days: -30,
    }),
    show_comparison: false,
  };
}
initialFilterParams ={...initialFilterParams, date_type:date_type}
const DashboardProvider = props => {
  const toast = useToastr();
  const [providers, setProviders] = useState([
    {
      provider_name: 'Dr.James mary',
      cq_score: 0,
      cq_score_diff: 0.0,
      archived_date: '2022-08-13T07:51:28Z',
    },
  ]);
  const authContext = useContext(AuthContext);
  const loggedInUser = useMemo(() => authContext?.currentUser, [authContext?.currentUser])
  const [hospitals, setHospitals] = useState([]);
  const [uploads, setUploads] = useState([]);
  const [isProviderLoading, iplState] = useBoolean(false);
  const [isHospitalLoading, ihlState] = useBoolean(false);
  const [isUploadsLoading, iulState] = useBoolean(false);
  const [isChartActivityLoading, icalState] = useBoolean(false);
  const [isRevenueOppLoading, irolState] = useBoolean(false);
  const [isChartAccuracyBreakdownLoading, setIsChartAccuracyBreakdownLoading] = useBoolean(false);
  const [isPotentialRevenueLoading, setIsPotentialRevenueLoading] = useBoolean(false);
  const [isTotalUploadLoading, itulState] = useBoolean(false);
  const [isCQScoreLoading, icqsState] = useBoolean(false);
  const [isRVUOppLoading, irvuoState] = useBoolean(false);
  const [isCQEstimatedRevLoading, icerState] = useBoolean(false);

  const [totalUpload, setTotalUpload] = useState({});
  const [cqScore, setCqScore] = useState({});
  const [rvuOpp, setRvuOpp] = useState({});
  const [revenueOpp, setRevenueOpp] = useState({});
  const [chartActivity, setChartActivity] = useState({});
  const [cqEstimatedRev, setCQEstimatedRev] = useState({});
  const [isAIRiskLoading, iarlState] = useBoolean(false);
  const [error, setError] = useState({
    TOTAL_UPLOADS: '',
    CQ_SCORE: '',
    RVU_OPPORTUNITY: '',
    AI_RISK: '',
  });

  const [aiRisk, setAIRisk] = useState({});
  const [chartAccuracyBreakdown, setChartAccuracyBreakdown] = useState({});
  const [potentialRevenue, setPotentialRevenue] = useState({});
  const [charts, setCharts] = useState([]);
  const [uploadedChartsActivityRvu, setUploadedChartsActivityRvu] = useState([]);
  const [uploadedChartsActivityUpcoded, setUploadedChartsActivityUpcoded] = useState([]);
  const [uploadedChartsActivityDowncoded, setUploadedChartsActivityDowncoded] = useState([]);
  const [uploadedChartsActivityModifier, setUploadedChartsActivityModifier] = useState([]);
  const [chartFilters, setChartFilters] = useState({ search: '' });
  const [filterParams, setFilterParams] = useState(
    Object.assign({}, initialFilterParams)
  );
  const [providerFilter, setProviderFilter] = useState({ search: '' });
  const [hospitalFilter, setHospitalFilter] = useState({ search: '' });

  const [userTypes, setUserType] = useState({});

  const [auditResults, setAuditResults] = useState([]);
  const [isFetchingAuditResults, ifarState] = useBoolean(false);
  const [isFetchingChartActivityRvu, setIsFetchingChartActivityRvu] = useBoolean(false);
  const [isFetchingChartActivityUpcoded, setIsFetchingChartActivityUpcoded] = useBoolean(false);
  const [isFetchingChartActivityDowncoded, setIsFetchingChartActivityDowncoded] = useBoolean(false);
  const [isFetchingChartActivityModifier, setIsFetchingChartActivityModifier] = useBoolean(false);

  const [isFileLoading, iflState] = useBoolean(false);
  const [dropdown, setDropdown] = useState([]);
  const [rvuOppFilter, setRVUOppFilter] = useState({
    rvu_opportunity_type: '',
  });
  const [showComparison, setShowComparison] = useState(false);
  const [chartCurrentPage, setChartCurrentpage] = useState(null);
  const [isGenerateAIResponseLoading, setIsGenerateAIResponseLoading] = useBoolean(false);

  const [treeData, setTreeData] = useState([]);
  const [isHierarchyLoading, ihtState] = useBoolean(false);
  const [totalBatchMetadata, setTotalBatchMetadata] = useState({})

  const [stateSpecialtiesMapping, setStateSpecialtiesMapping] = useState({})
  const [allStates, setAllStates] = useState([])
  const [allSpecialties, setAllSpecialties] = useState([]);
  const [isRVUOppDropdownLoading, irvuoolState] = useBoolean(true);
  const [DEFAULT_RVU_DOPDOWN, set_DEFAULT_RVU_DOPDOWN] = useState("em_level_distribution");
  const DEFAULT_CLIENT_STATE = useMemo(() => ({
      value: 0, 
      label: stateSpecialtiesMapping?.states?.[0]?.name ?? 'All States'
  }), [])
  const DEFAULT_CLIENT_SPECIALTY = useMemo(() => ({
      value: 0, 
      label: stateSpecialtiesMapping?.states?.[0]?.specialties?.[0]?.name ?? 'All Specialties'
  }))
  const DEFAULT_CMS_STATE = useMemo(() => ({
      value: 0, 
      label: allStates?.[0]?.name ?? 'All States'
  }), [])
  const DEFAULT_CMS_SPECIALTY = useMemo(() => ({
      value: 0, 
      label: allSpecialties?.[0]?.name ?? 'All Specialties'
  }), [])
  const DEFAULT_EANDM_OPTIONS = useMemo(() => ({
    selectedClientState: DEFAULT_CLIENT_STATE,
    selectedClientSpecialty: DEFAULT_CLIENT_SPECIALTY,
    selectedCMSState: DEFAULT_CMS_STATE,
    selectedCMSSpecialty: DEFAULT_CMS_SPECIALTY
  }), [])
  const [eandmSelectedOptions, setEandMSelectedOptions] = useState(DEFAULT_EANDM_OPTIONS);


  const getFilterParams = () => {
    const queryParams = {};
    const { start_date, end_date, label, date_type } = filterParams;

    if (label) queryParams['filter'] = label.toLowerCase();
    if (date_type) queryParams['date_type'] = date_type.toLowerCase();
    if (filterParams.health_system_id)
      queryParams['health_system_id'] = filterParams.health_system_id;
    if (filterParams.hospital_id)
      queryParams['hospital_id'] = filterParams.hospital_id;
    if (filterParams.department_id)
      queryParams['department_id'] = filterParams.department_id;
    if (filterParams.provider_id)
      queryParams['provider_id'] = filterParams.provider_id;

    if (filterParams.label.toLowerCase() === 'custom') {
      queryParams['start_date'] = format(start_date, 'yyyy-MM-dd');
      queryParams['end_date'] = format(end_date, 'yyyy-MM-dd');
      if (filterParams.previous_start_date) {
        queryParams['previous_start_date'] = format(
          filterParams.previous_start_date,
          'yyyy-MM-dd'
        );
        queryParams['previous_end_date'] = format(
          filterParams.previous_end_date,
          'yyyy-MM-dd'
        );
      }
      delete queryParams['filter'];
    }
    return queryParams;
  };

  const getAllStates = async () => {
    try {
      const res = await dashboardRepository.getStates({});
      res.unshift({
        id: 0,
        name: 'All States',
        abbr: "All States"
      })
      setAllStates(res);
      return res;
    } catch (err) {
      toast.showError({
        description: String(err)
      })
    } finally {
    }
  }

  const getAllSpecialties = async () => {
    try {
      const res = await dashboardRepository.getSpecialties({});
      res.unshift({
        id: 0,
        name: "All Specialties"
      });
      setAllSpecialties(res);
      return res;
    } catch (err) {
      toast.showError({
        description: String(err)
      })
    } finally {
    }
  }

  const handleStateSpecialtyMapping = (data) => {
    let allSpecs = [];
    (data?.order ?? []).forEach(id => {
      (data?.states[id]?.specialties ?? []).unshift({
      id: 0,
      name: "All Specialties"
    })
  })
    switch (loggedInUser?.user_type) {
        case ClientType.HEALTH_SYSTEM:
          allSpecs = [...new Map(
              (data?.order ?? [])
                .flatMap(id => data?.states[id]?.specialties ?? [])
                .map(specialty => [specialty.id, specialty])
            ).values()]
              .sort((a, b) => a.name.localeCompare(b.name));
          data.states[0] = {
            name: 'All States',
            abbr: 'All States',
            specialties: allSpecs
          }
          data.order.unshift(0);
          break;
        case ClientType.PHYSICIANS_GROUP:
            break;
        case ClientType.HOSPITAL:
            break;

        case ClientType.DEPARTMENT:
            break;
        
        case ClientType.PROVIDER:
            break;

        default:
            return;

    }
  }
  
  const getStateSpecialtiesMap = async () => {
    try {
      const res = await dashboardRepository.getStateSpecailtiesMap(getCurrentUserTypeIdObject(authContext.currentUser));
      handleStateSpecialtyMapping(res);
      setStateSpecialtiesMapping(res);
      return res;
    } catch (err) {
      toast.showError({
        description: String(err)
      })
    } finally {

    }
  }

  const handleApplyFilter = selectedFilters => {
    if (selectedFilters?.label?.toLowerCase() !== 'custom') {
      setShowComparison(false);
    }
    setFilterParams(selectedFilters);
  };

  const getProviders = async () => {
    try {
      const filter = getFilterParams();
      iplState.on();
      const response = await dashboardRepository.getProviders({
        ...filter,
        ...providerFilter,
      });
      setProviders(response);
      return response;
    } catch (err) {
      setProviders([]);
    } finally {
      iplState.off();
    }
  };

  const getUploads = async paginationParams => {
    try {
      const filter = getFilterParams();

      iulState.on();
      const response = await dashboardRepository.getChartUploads({
        ...filter,
        ...paginationParams,
      });
      setUploads(response.results);
      return response;
    } catch (err) {
      setUploads([]);
    } finally {
      iulState.off();
    }
  };
  const getHospitals = async paginationParams => {
    try {
      ihlState.on();
      // const filter = getFilterParams();
      const response = await dashboardRepository.getHospitals({
        // ...filter,
        ...hospitalFilter,
        ...paginationParams,
      });
      if (response.results) {
        setHospitals(response.results);
      }
      return response;
    } catch (err) {
      toast.showError({
        description: `Something went wrong.`,
      });
      setHospitals([]);
    } finally {
      ihlState.off();
    }
  };

  const getDepartments = async paginationParams => {
    try {
      ihlState.on();
      // const filter = getFilterParams();
      const response = await hospitalDashboardRepository.getHospitalDepartments(
        {
          // ...filter,
          ...hospitalFilter,
          ...paginationParams,
        }
      );
      setHospitals(response);
      return response;
    } catch (err) {
      toast.showError({
        description: `Something went wrong.`,
      });
      setHospitals([]);
    } finally {
      ihlState.off();
    }
  };
  const getPhysicians = async paginationParams => {
    try {
      ihlState.on();
      // const filter = getFilterParams();
      const response = await departmentDashboardRepository.getPhysicians({
        // ...filter,
        ...hospitalFilter,
        ...paginationParams,
      });
      setHospitals(response);
      if (response.results) {
        setHospitals(response.results);
      }
      return response;
    } catch (err) {
      toast.showError({
        description: `Something went wrong.`,
      });
      setHospitals([]);
    } finally {
      ihlState.off();
    }
  };
  const getChartActivity = async queryParams => {
    try {
      const filter = getFilterParams();
      icalState.on();
      const response = await dashboardRepository.getChartActivity({
        ...filter,
        ...queryParams,
      });
      setChartActivity(response);
      return response;
    } catch (err) {
      toast.showError({
        description: `Something went wrong.`,
      });
      setChartActivity({});
    } finally {
      icalState.off();
    }
  };

  const getChartActivityRvu = async (paginationParams) => {
    try {
      setIsFetchingChartActivityRvu.on(); 
      const response = await getChartActivityDetailUp({ ...paginationParams, metricType: 'rvu' });
      setUploadedChartsActivityRvu(response);
      return response;
    } catch (err) {
      toast.showError({ description: `Something went wrong with RVU charts.` });
    } finally {
      setIsFetchingChartActivityRvu.off(); 
    }
  };

  const getChartActivityUpcoded = async (paginationParams) => {
    try {
      setIsFetchingChartActivityUpcoded.on(); 
      const response = await getChartActivityDetailUp({ ...paginationParams, metricType: 'upcoded' });
      setUploadedChartsActivityUpcoded(response);
      return response;
    } catch (err) {
      toast.showError({ description: `Something went wrong with Upcoded charts.` });
    } finally {
      setIsFetchingChartActivityUpcoded.off(); 
    }
  };

  const getChartActivityDowncoded = async (paginationParams) => {
    try {
      setIsFetchingChartActivityDowncoded.on();
      const response = await getChartActivityDetailUp({ ...paginationParams, metricType: 'downcoded' });
      setUploadedChartsActivityDowncoded(response);
      return response;
    } catch (err) {
      toast.showError({ description: `Something went wrong with Downcoded charts.` });
    } finally {
      setIsFetchingChartActivityDowncoded.off();
    }
  };

  const getChartActivityModifier = async (paginationParams) => {
    try {
      setIsFetchingChartActivityModifier.on(); 
      const response = await getChartActivityDetailUp({ ...paginationParams, metricType: 'modifier' });
      setUploadedChartsActivityModifier(response);
      return response;
    } catch (err) {
      toast.showError({ description: `Something went wrong with Modifier charts.` });
    } finally {
      setIsFetchingChartActivityModifier.off();
    }
  };

  const getChartActivityDetailUp = async (paginationParams) => {
    try {
      const filter = getFilterParams();
      delete filter?.start_date;
      delete filter?.previous_end_date;
      delete filter?.previous_start_date;
      delete filter?.end_date;

      if (chartCurrentPage) {
        paginationParams.page = chartCurrentPage;
      }

      const response = await dashboardRepository.getChartActivityDetailUp({
        ...paginationParams,
        ...chartFilters,
        filter: 'year',
        ...filter,
        ...userTypes,
      });

      return response;
    } catch (err) {
      throw err; 
    }
  };

  const getRevenueOpp = async () => {
    try {
      const filter = getFilterParams();
      irolState.on();
      const response = await dashboardRepository.getOutstandingRevenue(filter);
      setError(prev => ({ ...prev, OUTSTANDING_REVENUE: null }));
      setRevenueOpp(response);
      return response;
    } catch (err) {
      const response = err.cause;
      if (response.message) {
        setError(prev => ({ ...prev, OUTSTANDING_REVENUE: response.message }));
      }
      setRevenueOpp({});
    } finally {
      irolState.off();
    }
  };

  const getChartAccuracyBreakdown = async () => {
    try {
      setIsChartAccuracyBreakdownLoading.on();
      const filter = getFilterParams();
      if (filter.health_system_id) {
        filter.entity_type = 'health_system';
        filter.entity_id = filter.health_system_id;
      }
      if (filter.hospital_id) {
        filter.entity_type = 'hospital';
        filter.entity_id = filter.hospital_id;
      }
      if (filter.department_id) {
        filter.entity_type = 'department';
        filter.entity_id = filter.department_id;
      }
      if (filter.provider_id) {
        filter.entity_type = 'provider';
        filter.entity_id = filter.provider_id;
      }
      const response = await dashboardRepository.getChartAccuracyBreakdown(filter);

      let label = '';
      if (filter.health_system_id) label = 'Hospitals';
      if (filter.hospital_id) label = 'Departments';
      if (filter.department_id) label = 'Physicians';
      // if (filter.provider_id) label = ''

      setChartAccuracyBreakdown({ ...response, label });
      setError(prev => ({ ...prev, CHART_ACCURACY_BREAKDOWN: null }));
      return response;
    } catch (err) {
      const response = err.cause;
      if (response.message) {
        setError(prev => ({ ...prev, CHART_ACCURACY_BREAKDOWN: response.message }));
      }
    } finally {
      setIsChartAccuracyBreakdownLoading.off();
    }
  };

  const getPotentialRevenue = async () => {
    try {
      setIsPotentialRevenueLoading.on();
      const filter = getFilterParams();
      const response = await dashboardRepository.getPotentialRevenue(filter);

      let label = '';
      if (filter.health_system_id) label = 'Hospitals';
      if (filter.hospital_id) label = 'Departments';
      if (filter.department_id) label = 'Physicians';
      // if (filter.provider_id) label = ''

      setPotentialRevenue({ ...response, label });
      setError(prev => ({ ...prev, POTENTIAL_REVENUE: null }));
    } catch (err) {
      const response = err.cause;
      if (response.message) {
        setError(prev => ({ ...prev, POTENTIAL_REVENUE: response.message }));
      }
    } finally {
      setIsPotentialRevenueLoading.off();
    }
  };

  const getTotalUploads = async () => {
    const filter = getFilterParams();
    try {
      itulState.on();
      const response = await dashboardRepository.getTotalUploads(filter);
      setError(prev => ({ ...prev, TOTAL_UPLOADS: null }));
      setTotalUpload(response);
    } catch (err) {
      const response = err.cause;
      if (response.message) {
        setError(prev => ({ ...prev, TOTAL_UPLOADS: response.message }));
      }
      setTotalUpload({});
    } finally {
      itulState.off();
    }
  };
  const getCQScore = async () => {
    const filter = getFilterParams();
    try {
      icqsState.on();
      const response = await dashboardRepository.getCQScore(filter);
      setError(prev => ({ ...prev, CQ_SCORE: null }));
      setCqScore(response);
    } catch (err) {
      const response = err.cause;
      if (response.message) {
        setError(prev => ({ ...prev, CQ_SCORE: response.message }));
      }
      setCqScore({});
    } finally {
      icqsState.off();
    }
  };
  const getRVUOpp = async (extraFilters = {}) => {
    const filter = getFilterParams();
    try {
      irvuoState.on();
      const response = await dashboardRepository.getRVUOpp({
        ...filter,
        ...rvuOppFilter,
        ...extraFilters
        // another_data: ['billed', 'rev'],
      });
      setError(prev => ({ ...prev, RVU_OPPORTUNITY: null }));
      setRvuOpp(response);
    } catch (err) {
      const response = err.cause;
      if (response.message) {
        setError(prev => ({ ...prev, RVU_OPPORTUNITY: response.message }));
      }
      setRvuOpp({});
    } finally {
      irvuoState.off();
    }
  };
  const getCQEstimatedRev = async () => {
    const filter = getFilterParams();
    try {
      icerState.on();
      const response = await dashboardRepository.getCQEstimatedRev(filter);
      setError(prev => ({ ...prev, CQ_ESTIMATED_REVENUE: null }));
      setCQEstimatedRev(response);
    } catch (err) {
      const response = err.cause;
      if (response.message) {
        setError(prev => ({ ...prev, CQ_ESTIMATED_REVENUE: response.message }));
      }
      setCQEstimatedRev({});
    } finally {
      icerState.off();
    }
  };

  const getCharts = async paginationParams => {
    try {
      chartFilters['user'] = SELF;
      chartFilters['status'] = ['RECEIVED', 'PROCESSING'];
      const filter = getFilterParams();
      ihlState.on();
      const response = await myChartRepository.getCharts({
        ...paginationParams,
        ...chartFilters,
        ...filter,
      });
      setCharts(response.results);
      return response;
    } catch (err) {
      toast.showError({
        description: `Something went wrong.`,
      });
      setCharts([]);
    } finally {
      ihlState.off();
    }
  };


  const getAuditResults = async paginationParams => {
    try {
      const filter = getFilterParams();
      delete filter?.start_date;
      delete filter?.previous_end_date;
      delete filter?.previous_start_date;
      delete filter?.end_date;
      ifarState.on();

      if (chartCurrentPage) {
        paginationParams.page = chartCurrentPage;
      }


      const response = await myChartRepository.getAuditResults({
        ...paginationParams,
        ...chartFilters,
        filter: 'year',
        ...filter,
        ...userTypes,
      });

      setAuditResults(response.results);

      return response;
    } catch (err) {
      // toast.showError({
      //   description: `Something went wrong.`,
      // });
      setAuditResults([]);
    } finally {
      ifarState.off();
    }
  };

  const getFileObjectByBatchId = async batchId => {
    try {
      iflState.on();
      const response = await dashboardRepository.getFileObjectByBatchId(
        batchId
      );
      return response;
    } catch (err) {
      toast.showError({
        description: `Something went wrong.`,
      });
    } finally {
      iflState.off();
    }
  };

  const getAIRisk = async () => {
    try {
      iarlState.on();
      const filter = getFilterParams();
      const response = await dashboardRepository.getAIRisk(filter);
      let label = '';
      if (filterParams.health_system_id) label = 'Hospitals';
      if (filterParams.hospital_id) label = 'Departments';
      if (filterParams.department_id) label = 'Physicians';
      // if (filterParams.provider_id) label = ''
      setAIRisk({ ...response, label });
      setError(prev => ({ ...prev, AI_RISK: null }));
    } catch (err) {
      const response = err.cause;
      if (response.message) {
        setError(prev => ({ ...prev, AI_RISK: response.message }));
      }
      setCharts({});
    } finally {
      iarlState.off();
    }
  };

  const getRVUOppDropdown = async queryParams => {
    try {
      irvuoolState.on();
      iflState.on();
      irvuoState.on();
      const filter = getFilterParams();
      const response = await dashboardRepository.getRVUOppDropdown({
        ...queryParams,
        ...filter,
      });
      let temp = [];
      if (Object.keys(response).length && Array.isArray(response) && response.length) {
        response.forEach(r => {
          temp.push({
            label: r[1],
            value: r[0],
          });
        });
      } else {
        setRvuOpp({ message: 'No data present for this account' });
        irvuoState.off();
      }
      setDropdown(temp);
    } catch (err) {
      toast.showError({
        description: `Something went wrong.`,
      });
      setDropdown([]);
    } finally {
      iflState.off();
      irvuoState.off();
      irvuoolState.off();
    }
  };

  const generateAiResponse = async (option, data, dateFilter) => {
    const payload = {
      tile: option,
      data: data,
      date_filter: dateFilter,
    };
    try {
      setIsGenerateAIResponseLoading.on();
      const response = await dashboardRepository.generateAiResponse(payload);
      return response;
    } catch (err) {
      toast.showError({
        description: `Error generating AI response`,
      });
    } finally {
      setIsGenerateAIResponseLoading.off();
    }
  };

  const getHierarchyTree = async (entityType, entityId, extraParams = {}) => {
    try {
      ihtState.on();
      const response = await dashboardRepository.getHierarchyTree({
        entity_type: entityType,
        entity_id:   entityId,
        ...extraParams,
      });
      // Transform the nested API response → flat subRows shape for CQTreeTable
      const transformed = transformHierarchyResponse(response);
      setTreeData(transformed);
      return transformed;
    } catch (err) {
      toast.showError({ description: 'Something went wrong.' });
      setTreeData([]);
    } finally {
      ihtState.off();
    }
  };

  const getHierarchyTreeWithMetrics = async (extraParams = {}) => {
    try {
      ihtState.on();
      const filter = getFilterParams();
      const response = await dashboardRepository.getHierarchyTreeWithMetrics({
        ...getCurrentUserTypeIdObject(authContext.currentUser),
        ...extraParams,
        ...filter
      });
      // Transform the nested API response → flat subRows shape for CQTreeTable
      setTotalBatchMetadata({
        status_details: response?.batch_metadata ?? {},
        avg_score: response?.avg_score,
        total_rvu: response?.total_rvu
      })
      const transformed = transformHierarchyResponse(response);
      setTreeData(transformed);
      return response;
    } catch (err) {
      toast.showError({ description: 'Something went wrong.' });
      setTreeData([]);
    } finally {
      ihtState.off();
    }
  };

  const getHospitals1 = usePagination(getHospitals);
  const getDepartments1 = usePagination(getDepartments);
  const getPhysicians1 = usePagination(getPhysicians);
  const getUploads1 = usePagination(getUploads);
  const getCharts1 = usePagination(getCharts);
  const getChartActivityRvu1 = usePagination(getChartActivityRvu);
  const getChartActivityUpcoded1 = usePagination(getChartActivityUpcoded);
  const getChartActivityDowncoded1 = usePagination(getChartActivityDowncoded);
  const getChartActivityModifier1 = usePagination(getChartActivityModifier);
  const getAuditCharts1 = usePagination(getAuditResults);

  const mContext = {
    getProviders,
    getHospitals: getHospitals1,
    getDepartments: getDepartments1,
    getPhysicians: getPhysicians1,
    getUploads: getUploads1,
    providers,
    hospitals,
    uploads,
    filterParams,
    handleApplyFilter,
    treeData,
    isHierarchyLoading,
    getHierarchyTree,

    isProviderLoading,
    isHospitalLoading,
    isUploadsLoading,
    isChartActivityLoading,
    isRevenueOppLoading,
    hospitalFilter,
    setHospitalFilter,
    providerFilter,
    setProviderFilter,
    getChartActivity,
    getChartActivityRvu: getChartActivityRvu1,
    getChartActivityUpcoded: getChartActivityUpcoded1,
    getChartActivityDowncoded: getChartActivityDowncoded1,
    getChartActivityModifier: getChartActivityModifier1,
    getRevenueOpp,
    getChartAccuracyBreakdown,
    chartAccuracyBreakdown,
    isChartAccuracyBreakdownLoading,
    getPotentialRevenue,
    potentialRevenue,
    isPotentialRevenueLoading,
    isTotalUploadLoading,
    totalUpload,
    getTotalUploads,
    isCQScoreLoading,
    cqScore,
    getCQScore,
    isRVUOppLoading,
    rvuOpp,
    revenueOpp,
    chartActivity,
    getRVUOpp,
    charts,
    uploadedChartsActivityRvu,
    uploadedChartsActivityUpcoded,
    uploadedChartsActivityDowncoded,
    uploadedChartsActivityModifier,
    chartFilters,
    setChartFilters,
    getCharts: getCharts1,
    getFileObjectByBatchId,
    isFileLoading,
    getCQEstimatedRev,
    cqEstimatedRev,
    isCQEstimatedRevLoading,
    getAIRisk,
    aiRisk,
    isAIRiskLoading,
    getRVUOppDropdown,
    dropdown,
    setRVUOppFilter,
    rvuOppFilter,
    error,
    showComparison,
    setShowComparison,
    getFilterParams,

    //audit results

    getAuditCharts: getAuditCharts1,
    auditResults,
    isFetchingAuditResults,
    isFetchingChartActivityRvu,
    isFetchingChartActivityUpcoded,
    isFetchingChartActivityDowncoded,
    isFetchingChartActivityModifier,
    setUserType,

    userTypes,

    chartCurrentPage,
    setChartCurrentpage,
    generateAiResponse,
    isGenerateAIResponseLoading,
    setIsGenerateAIResponseLoading,

    getStateSpecialtiesMap,
    stateSpecialtiesMapping,
    getAllStates, 
    getAllSpecialties,
    allStates,
    allSpecialties,
    eandmSelectedOptions,
    setEandMSelectedOptions,
    DEFAULT_CLIENT_STATE,
    DEFAULT_CLIENT_SPECIALTY,
    DEFAULT_CMS_STATE,
    DEFAULT_CMS_SPECIALTY,
    isRVUOppDropdownLoading,
    irvuoolState,
    DEFAULT_EANDM_OPTIONS,
    DEFAULT_RVU_DOPDOWN,
    set_DEFAULT_RVU_DOPDOWN,
    getHierarchyTreeWithMetrics,
    totalBatchMetadata,
    setTotalBatchMetadata
  };

  return (
    <DashboardContext.Provider value={mContext}>
      {props.children}
    </DashboardContext.Provider>
  );
};
export default DashboardProvider;
